<template>
  <artisio-modal :visible="show" :title="title" body-class="qr-code-modal pb-3" size="lg" hide-footer
                 :content-in-form="false" @hide="hideModal" @shown="onShown">

    <div class="row">
      <div class="col-md-4">
        <b-form-group id="input-group-3" :label="$t('Choose Webcam')" label-for="input-3">
          <b-form-select @change="onCameraSelect" placeholder="Select webcam"
                         id="input-3" text-field="label" label-field="label"
                         v-model="currentWebcam" value-field="deviceId"
                         :options="availableWebcams">
            <template #first>
              <b-form-select-option :value="null" disabled>{{ $t('Please select a webcam') }}</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col-md-4 d-flex align-items-center">
        <b-button class="mr-2" variant="danger" style="margin-top: 1em" @click="takePhoto"
                  :disabled="loading || !currentWebcam" v-if="isPhotoTaken">
          <font-awesome-icon icon="undo" class="icon"/>
          {{ $t('Dismiss') }}
        </b-button>

        <b-button variant="primary" style="margin-top: 1em" @click="confirmPhoto"
                  :disabled="loading || !currentWebcam" v-if="isPhotoTaken">
          <font-awesome-icon icon="check" class="icon"/>
          {{ $t('Confirm') }}
        </b-button>
        <b-button variant="primary" style="margin-top: 1em" @click="takePhoto"
                  :disabled="loading || !currentWebcam" v-else>
          <font-awesome-icon icon="camera" class="icon"/>
          {{ $t('Take Picture') }}
        </b-button>
      </div>
    </div>

    <!--    <div class="camera-button">-->
    <!--      <button type="button" class="button is-rounded"-->
    <!--              :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">-->
    <!--        <span v-if="!isCameraOpen">Open Camera</span>-->
    <!--        <span v-else>Close Camera</span>-->
    <!--      </button>-->
    <!--    </div>-->

    <div v-show="isCameraOpen && loading" class="camera-loading">
      <spinner spinner-size="6" show/>
    </div>

    <div v-if="isCameraOpen" v-show="!loading" class="camera-box" :class="{ 'flash' : isShotPhoto }">

      <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

      <video v-show="!isPhotoTaken" ref="camera" autoplay></video>

      <canvas v-show="isPhotoTaken" id="photoCanvs" ref="canvas" style="width: 100%"></canvas>
    </div>

  </artisio-modal>
</template>

<script>
  import EventBus from "../../../plugins/event-bus";
  import {
    ON_CAMERA_MODAL_OPEN
  } from "@/plugins/event-bus/event-bus-names";
  import Spinner from "../common/Spinner";
  import ArtisioModal from "../artisio-modal/ArtisioModal";
  import {uuid} from 'vue-uuid';
  import {PREFERRED_CAMERA_DEVICE_ID} from "@/modules/constants";

  export default {
    name: "CameraModal",
    components: {ArtisioModal, Spinner},
    data() {
      return {
        isCameraOpen: false,
        isPhotoTaken: false,
        isShotPhoto: false,
        loading: false,
        link: '#',
        show: false,
        title: this.$i18n.t("Camera"),
        availableWebcams: [],
        currentWebcam: null,
        emitKey: null
      }
    },
    methods: {
      toggleCamera() {
        this.stopCameraStream();
        this.isCameraOpen = true;
        this.createCameraElement();
      },
      async createCameraElement() {
        this.loading = true;

        const widthValues = [3840, 2560, 1920, 1600, 1080, 720, 576]

        for (let width of widthValues) {
          const constraints = (window.constraints = {
            audio: false,
            video: {
              deviceId: {exact: this.currentWebcam},
              width: {min: width}
            }
          });

          try {
            let stream = await navigator.mediaDevices.getUserMedia(constraints)
            this.loading = false;
            this.$refs.camera.srcObject = stream;

            // Wait for the video metadata to load to access the video dimensions
            this.$refs.camera.onloadedmetadata = () => {
              // Calculate the proportional dimensions of the video element based on the aspect ratio
              const aspectRatio = this.$refs.camera.videoWidth / this.$refs.camera.videoHeight;
              const maxWidth = 770; // Adjust this value to your desired maximum width
              const maxHeight = maxWidth / aspectRatio;

              // Set the dimensions of the video element
              this.$refs.camera.width = maxWidth;
              this.$refs.camera.height = maxHeight;
            };
            this.setPreferredCamera()
            break;
          } catch (error) {
            this.loading = false;
            // alert("May the browser didn't support or there is some errors.");
          }
        }
      },
      stopCameraStream() {
        if (this.isCameraOpen) {
          this.isCameraOpen = false;
          this.isPhotoTaken = false;
          this.isShotPhoto = false;
          let tracks = this.$refs.camera.srcObject.getTracks();
          tracks.forEach(track => {
            track.stop();
          });
        }
      },
      takePhoto() {
        if (!this.isPhotoTaken) {
          this.isShotPhoto = true;

          const FLASH_TIMEOUT = 50;

          setTimeout(() => {
            this.isShotPhoto = false;
          }, FLASH_TIMEOUT);
        }

        this.isPhotoTaken = !this.isPhotoTaken;

        this.$refs.canvas.width = this.$refs.camera.videoWidth;
        this.$refs.canvas.height = this.$refs.camera.videoHeight;
        console.log(this.$refs.canvas.width);
        console.log(this.$refs.canvas.height);
        const context = this.$refs.canvas.getContext('2d');
        context.drawImage(this.$refs.camera, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      },
      getFileObjFromCanvas() {
        // Convert the canvas content to a data URL
        const dataURL = this.$refs.canvas.toDataURL('image/png');

        // Convert the data URL to a Blob object
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], {type: mimeString});

        // Generate a file object from the Blob
        return new File([blob], `${uuid.v4()}.png`, {type: mimeString});
      },
      confirmPhoto() {
        let file = this.getFileObjFromCanvas()
        this.$evBus.$emit(this.emitKey, {file: file})
        this.hideModal()
      },
      async onShown() {
        await this.enumerateConnectedWebcams();
        let deviceId = this.getPreferredCamera()
        if (deviceId) {
          this.currentWebcam = deviceId;
          this.toggleCamera()
        }
      },
      hideModal() {
        this.stopCameraStream()
        this.show = false;
        this.availableWebcams = [];
        this.currentWebcam = null
        this.loading = false
        this.emitKey = null
      },
      onCameraSelect() {
        this.toggleCamera()
      },
      async enumerateConnectedWebcams() {
        this.loading = true
        try {
          let devices = await navigator.mediaDevices.enumerateDevices()
          this.availableWebcams = devices.filter(function (device) {
            return device.kind === 'videoinput';
          }).map(i => {
            return {deviceId: i.deviceId, label: i.label}
          });
        } catch (error) {
          console.error('Error enumerating media devices:', error);
        }
        this.loading = false
        return true
      },
      setPreferredCamera() {
        localStorage.setItem(PREFERRED_CAMERA_DEVICE_ID, this.currentWebcam)
      },
      getPreferredCamera() {
        return localStorage.getItem(PREFERRED_CAMERA_DEVICE_ID)
      },
    },
    beforeMount() {
      this.show = false;
      EventBus.$on(ON_CAMERA_MODAL_OPEN, (data) => {
        this.show = true
        this.emitKey = data.emitKey
      });
    },
    beforeDestroy() {
      this.show = false
      EventBus.$off(ON_CAMERA_MODAL_OPEN);
    }
  }
</script>

<style lang="scss">
  .pdf-document {
    .items-table {
      td {
        &:first-child {
          overflow-wrap: anywhere;
        }
      }
    }
  }
</style>
